var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9179 20.7798C15.4573 18.4685 19 14.6408 19 9.98687C19 5.02356 14.9706 1 10 1C5.02943 1 1 5.02356 1 9.98687C1 14.6408 4.54273 18.4685 9.08211 20.7798C9.6589 21.0734 10.3411 21.0734 10.9179 20.7798Z",
    stroke: "#FFC44D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 11.6569 11.6569 13 10 13C8.3431 13 7 11.6569 7 10C7 8.34315 8.3431 7 10 7C11.6569 7 13 8.34315 13 10Z",
    stroke: "#FFC44D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.48724e53889070cfea11df89950a2a56.svg";
export { ForwardRef as ReactComponent };